export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header with gradient accent */}
      <div className="border-b border-[#1A1A1A] bg-gradient-to-r from-[#0A0A0A] via-[#0F0F0F] to-[#0A0A0A]">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <div className="flex items-center gap-3 mb-2">
            <a 
              href="/" 
              className="text-[#3ECF8E] hover:text-[#35b87d] transition-colors"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
            </a>
            <h1 className="text-4xl font-bold text-white">Conditions d'Utilisation</h1>
          </div>
          <div className="ml-9 space-y-1">
            <p className="text-gray-400 text-sm">Application : Avocat AI</p>
            <p className="text-gray-400 text-sm">Dernière mise à jour : 11/02/2026</p>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-[#0A0A0A] border border-[#1A1A1A] rounded-2xl p-10 shadow-2xl">
          <div className="prose prose-invert max-w-none space-y-10">
            <section className="scroll-mt-20">
              <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-[#3ECF8E] rounded-full"></span>
                1. Acceptation des conditions
              </h2>
              <p className="text-gray-300 leading-relaxed text-[15px]">
                En créant un compte et en utilisant Avocat AI, tu acceptes pleinement les présentes conditions.
              </p>
            </section>

            <section className="scroll-mt-20">
              <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-[#3ECF8E] rounded-full"></span>
                2. Nature du service
              </h2>
              <p className="text-gray-300 mb-4 leading-relaxed text-[15px]">
                Avocat AI est un outil d'information juridique basé sur l'intelligence artificielle.
              </p>
              <div className="bg-[#0F0F0F] border-l-4 border-[#3ECF8E] p-4 rounded-r-lg mb-4">
                <p className="text-gray-300 mb-3 text-[15px]">
                  <strong className="text-white">Ce que nous ne sommes pas :</strong>
                </p>
                <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2 ml-4 text-[15px]">
                  <li>Un cabinet d'avocats</li>
                  <li>Un conseil juridique professionnel</li>
                  <li>Une assistance en justice</li>
                </ul>
                <p className="text-gray-300 mb-3 text-[15px]">
                  <strong className="text-white">Ce que nous sommes :</strong>
                </p>
                <ul className="list-disc list-inside text-gray-300 mb-3 space-y-2 ml-4 text-[15px]">
                  <li>Un assistant conversationnel qui t'aide à comprendre le droit tunisien</li>
                  <li>Un outil de recherche d'articles de loi et de textes juridiques</li>
                  <li>Une aide à la veille documentaire</li>
                </ul>
              </div>
              <p className="text-gray-400 italic text-sm">
                *Aucune relation avocat-client n'est créée entre toi et l'application.
              </p>
            </section>

            <section className="scroll-mt-20">
              <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-[#3ECF8E] rounded-full"></span>
                3. Limites de l'intelligence artificielle
              </h2>
              <p className="text-gray-300 mb-4 leading-relaxed text-[15px]">
                L'IA peut se tromper. Elle peut fournir des informations :
              </p>
              <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2 ml-4 text-[15px]">
                <li>Incomplètes</li>
                <li>Imprécises</li>
                <li>Partiellement obsolètes</li>
              </ul>
              <p className="text-gray-300 mb-4 leading-relaxed text-[15px]">
                Tu es seul responsable de l'utilisation que tu fais des réponses.
              </p>
              <p className="text-gray-300 leading-relaxed text-[15px]">
                Pour toute décision importante (contractuelle, judiciaire, administrative), consulte obligatoirement un avocat inscrit au barreau tunisien.
              </p>
            </section>

            <section className="scroll-mt-20">
              <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-[#3ECF8E] rounded-full"></span>
                4. Utilisation autorisée
              </h2>
              <p className="text-gray-300 mb-4 leading-relaxed text-[15px]">
                Tu as le droit d'utiliser l'application pour un usage strictement personnel et non commercial.
              </p>
              <p className="text-gray-300 mb-3 text-[15px]">
                <strong className="text-white">Il t'est interdit de :</strong>
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4 text-[15px]">
                <li>Copier, redistribuer ou vendre les réponses générées</li>
                <li>Utiliser le service à des fins illégales</li>
                <li>Tenter de contourner les mesures de sécurité</li>
                <li>Créer plusieurs comptes pour abuser du service</li>
              </ul>
            </section>

            <section className="scroll-mt-20">
              <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-[#3ECF8E] rounded-full"></span>
                5. Compte et sécurité
              </h2>
              <p className="text-gray-300 mb-4 leading-relaxed text-[15px]">
                Tu es responsable de la confidentialité de ton mot de passe.
              </p>
              <p className="text-gray-300 mb-4 leading-relaxed text-[15px]">
                Si tu constates une utilisation non autorisée de ton compte, préviens-nous immédiatement.
              </p>
              <p className="text-gray-300 leading-relaxed text-[15px]">
                Nous nous réservons le droit de suspendre ou supprimer tout compte en cas de violation des présentes conditions.
              </p>
            </section>

            <section className="scroll-mt-20">
              <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-[#3ECF8E] rounded-full"></span>
                6. Responsabilité
              </h2>
              <p className="text-gray-300 mb-3 text-[15px]">Notre responsabilité ne peut pas être engagée pour :</p>
              <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2 ml-4 text-[15px]">
                <li>Les erreurs ou omissions dans les réponses générées</li>
                <li>Les décisions que tu prends sur la base de ces informations</li>
                <li>Les dommages indirects (perte de temps, perte d'argent, préjudice moral)</li>
                <li>L'interruption temporaire du service</li>
              </ul>
              <p className="text-gray-300 leading-relaxed text-[15px]">
                En clair : on fait de notre mieux, mais on n'est pas parfaits. Tu utilises l'application à tes risques et périls.
              </p>
            </section>

            <section className="scroll-mt-20">
              <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-[#3ECF8E] rounded-full"></span>
                7. Propriété intellectuelle
              </h2>
              <p className="text-gray-300 mb-4 leading-relaxed text-[15px]">
                L'application, son code, son design, sa marque et sa base de données juridique sont la propriété exclusive de Avocat AI
              </p>
              <p className="text-gray-300 leading-relaxed text-[15px]">
                Tu ne peux pas reproduire, modifier ou distribuer ces éléments sans autorisation écrite.
              </p>
            </section>

            <section className="scroll-mt-20">
              <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-[#3ECF8E] rounded-full"></span>
                8. Facturation et remboursement
              </h2>
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-semibold text-white mb-3">8.1 Aucun remboursement</h3>
                  <p className="text-gray-300 mb-4 leading-relaxed text-[15px]">
                    Une fois le paiement effectué, aucun remboursement n'est accordé, quelle qu'en soit la raison.
                  </p>
                  <p className="text-gray-300 mb-6 leading-relaxed text-[15px]">
                    L'abonnement est payé d'avance. Le service est considéré comme consommé dès l'accès accordé.
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-3">8.2 Suppression du compte = perte de l'abonnement</h3>
                  <p className="text-gray-300 mb-4 leading-relaxed text-[15px]">
                    Si tu supprimes ton compte, ton abonnement est immédiatement perdu et définitivement résilié.
                  </p>
                  <p className="text-gray-300 mb-6 leading-relaxed text-[15px]">
                    Aucun remboursement ni transfert vers un autre compte n'est possible.
                  </p>
                  <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4 text-[15px]">
                    <li>L'application est actuellement gratuite. Nous nous réservons le droit de la rendre payante à l'avenir, avec une information préalable des utilisateurs</li>
                    <li>Pour les abonnements sont facturés mensuellement ou annuellement, sans engagement. Aucun remboursement n'est possible sauf dysfonctionnement technique avéré de notre part.</li>
                  </ul>
                </div>
              </div>
            </section>

            <section className="scroll-mt-20">
              <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-[#3ECF8E] rounded-full"></span>
                9. Suspension et résiliation
              </h2>
              <p className="text-gray-300 mb-3 text-[15px]">On peut suspendre ou résilier ton compte à tout moment si :</p>
              <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2 ml-4 text-[15px]">
                <li>Tu violes les présentes conditions</li>
                <li>Tu utilises le service de manière abusive</li>
              </ul>
              <p className="text-gray-300 leading-relaxed text-[15px]">
                Tu peux aussi supprimer ton compte à tout moment depuis les paramètres.
              </p>
            </section>

            <section className="scroll-mt-20">
              <h2 className="text-2xl font-semibold text-white mb-4 flex items-center gap-2">
                <span className="w-1 h-6 bg-[#3ECF8E] rounded-full"></span>
                10. Modifications des conditions
              </h2>
              <p className="text-gray-300 mb-4 leading-relaxed text-[15px]">
                On peut modifier ces conditions à tout moment, sans préavis.
              </p>
              <p className="text-gray-300 leading-relaxed text-[15px]">
                Si tu continues à utiliser l'application après une modification, tu es réputé avoir accepté les nouvelles conditions.
              </p>
            </section>
          </div>

          {/* Action Buttons */}
          <div className="mt-12 pt-8 border-t border-[#1A1A1A]">
            <div className="flex flex-col sm:flex-row gap-4 mb-6">
              <a
                href="/"
                className="flex-1 px-6 py-3.5 bg-[#3ECF8E] text-white font-medium rounded-lg hover:bg-[#34B27B] transition-all duration-200 text-center shadow-lg shadow-[#3ECF8E]/20 hover:shadow-[#3ECF8E]/30 hover:scale-[1.02] active:scale-[0.98]"
              >
                Accepter
              </a>
              <a
                href="/"
                className="flex-1 px-6 py-3.5 bg-[#0F0F0F] border border-[#1A1A1A] text-white font-medium rounded-lg hover:bg-[#1A1A1A] hover:border-[#2A2A2A] transition-all duration-200 text-center hover:scale-[1.02] active:scale-[0.98]"
              >
                Refuser
              </a>
            </div>
            <div className="text-center">
              <a 
                href="/" 
                className="inline-flex items-center gap-2 text-[#3ECF8E] hover:text-[#35b87d] transition-colors font-medium text-sm"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                Retour à l'accueil
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
